import * as React from "react";
import { ListItem } from "@mui/material";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import "../../../../App.scss";
import Role from "../../../../utils/interfaces/IRole";
import { useDispatch } from "react-redux";
import { setFilterRole } from "../../../../store/ducks/relatedRoles";
import "./glossaryList.scss";
interface GlossaryRoleListProps {
    item: Role;
}

const GlossaryRoleList = ({ item }: GlossaryRoleListProps) => {
    const dispatch = useDispatch();
    return (
        <>
            <ListItem className="listItemGlosarry">
                <Box
                    onClick={() => {
                        dispatch(setFilterRole(item));
                    }}
                >
                    <Box className="boxMargin">
                        {item.role.charAt(0) ? <Typography className="textRole">{item.role.charAt(0)}</Typography> : null}
                    </Box>
                    <Box className="boxItem">
                        <Box
                            className="bulletItem"
                            sx={{
                                backgroundColor: item.color,
                            }}
                        />
                        <Typography fontFamily="IliaMontSerrat" color="#1C1D38" fontWeight="700" fontSize="16px" lineHeight="19.5px">
                            {item?.trajectory?.trajectory}
                        </Typography>
                    </Box>
                    <Typography fontSize="14px" marginTop={1} variant="body2" color="textSecondary">
                        {item.role}
                    </Typography>
                </Box>
            </ListItem>
            <Divider component="li" />
        </>
    );
};

export default GlossaryRoleList;
